import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DirectorListPageUI from './DirectorListPageUI.js'
import LocalStorageKeys from '../../../cache/LocalStorageKeys'

class DirectorListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      directorList: null,
    }
  }

  render() {
    return (
      <DirectorListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        directorList={this.state.directorList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDirectors(context)
    this.getMessages(context)
  }

  getDirectors(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${context.session.accountId}/directors`,
      cacheKey: CacheKeys.Directors(context.session.accountId),
      callback: this.getDirectorsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDirectorsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      directorList: response.companyDirectorList,
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Directors(context.session.accountId))
    this.setState({
      errorList: null,
      directorList: null,
    }, () => {
      this.getDirectors(context)
    })
  }

  getMessages(context) {
    let arr = [
      'c_verify',
      'c_refresh',
      'c_no_dir_msg',
      'c_status_done',
      'c_kyc_verification'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_directors', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(DirectorListPageSF)
